export enum AnimationTypes {
    Quiz = 1,
    IdeaBox = 2,
    PhotoContest = 3,
    LuckyWheel = 4,
    ScratchGame = 5,
    MysteryCards = 6
}
